import { createAction, props } from '@ngrx/store';

export const STORE_FILE_1 = '[FilePartnerRegister] Store File to register partner (first file)';
export const STORE_FILE_2 = '[FilePartnerRegister] Store File to register partner (second file)';
export const STORE_FILE_3 = '[FilePartnerRegister] Store File to register partner (third file)';



export const storeFirstFilePartnerRegister = createAction(
  STORE_FILE_1,
  props<{file: File}>()
);

export const storeSecondFilePartnerRegister = createAction(
  STORE_FILE_2,
  props<{file: File}>()
);

export const storeThirdFilePartnerRegister = createAction(
  STORE_FILE_3,
  props<{file: File}>()
);
